import { AbstractControl, ValidatorFn } from '@angular/forms';

export const timeValidator: ValidatorFn = (control: AbstractControl): { [key: string]: boolean } | null => {
  const startTime = control.get('startTime')?.value;
  const endTime = control.get('endTime')?.value;

  if (startTime && endTime && startTime >= endTime) {
    return { 'invalidTime': true };
  }
  return null;
};
